import {FC} from 'react'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {KTSVG} from '../../../../../_metronic/helpers'

export type ListActionProps = {
  showModalCreate: () => void
}

const ListAction: FC<ListActionProps> = ({showModalCreate}) => {
  return (
    <div className='card-toolbar mt-0'>
      {AuthenticateUser('manage-sub-client-user') && (
        <button type='button' className='btn btn-primary' onClick={() => showModalCreate()}>
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
          Add Sub Account
        </button>
      )}
    </div>
  )
}

export default ListAction
